module.exports = __webpack_public_path__ + "img/undraw_completing_6bhr.80ed2b1e.svg";